<template>
  <div class="ni-list">
    <div v-if="store.filtered.length === 0" class="ni-list__empty">
      Нет записей
    </div>

    <div v-for="entry in store.filtered" :key="entry.id" class="ni-list__item-wrapper">
      <div class="ni-list__row" @click="toggle(entry.id)">
        <span class="ni-list__kind" :class="kindClass(entry)">
          {{ entry.kind === 'request' ? 'REQ' : 'EVT' }}
        </span>
        <span class="ni-list__subject">{{ entry.subject }}</span>
        <span v-if="entry.kind === 'request'" class="ni-list__duration">{{ entry.durationMs }}ms</span>
        <span
          v-if="entry.kind === 'request'"
          class="ni-list__status"
          :class="entry.status === 'ok' ? 'ni-list__status--ok' : 'ni-list__status--error'"
        >&#x25CF;</span>
        <span class="ni-list__time">{{ formatTime(entry.timestamp) }}</span>
      </div>
      <NatsInspectorDetail v-if="expanded === entry.id" :entry="entry" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { NatsTraceEntry } from './types'
import { useNatsInspectorStore } from './inspector-store'
import NatsInspectorDetail from './NatsInspectorDetail.vue'

const store = useNatsInspectorStore()
const expanded = ref<string | null>(null)

const toggle = (id: string) => {
  expanded.value = expanded.value === id ? null : id
}

const kindClass = (entry: NatsTraceEntry) =>
  entry.kind === 'request' ? 'ni-list__kind--req' : 'ni-list__kind--evt'

const formatTime = (iso: string): string => {
  const d = new Date(iso)
  const hh = String(d.getHours()).padStart(2, '0')
  const mm = String(d.getMinutes()).padStart(2, '0')
  const ss = String(d.getSeconds()).padStart(2, '0')
  const ms = String(d.getMilliseconds()).padStart(3, '0')
  return `${hh}:${mm}:${ss}.${ms}`
}
</script>

<style scoped>
.ni-list {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.ni-list__empty {
  padding: 40px 0;
  text-align: center;
  color: #666;
  font-size: 14px;
}

.ni-list__item-wrapper {
  border-bottom: 1px solid #2a2a2a;
}

.ni-list__row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 12px;
  cursor: pointer;
  transition: background 0.1s;
}

.ni-list__row:hover {
  background: #252525;
}

.ni-list__kind {
  font-size: 10px;
  font-weight: 700;
  padding: 1px 5px;
  border-radius: 3px;
  letter-spacing: 0.5px;
  flex-shrink: 0;
}

.ni-list__kind--req {
  background: #1a3a5c;
  color: #5b9bd5;
}

.ni-list__kind--evt {
  background: #3a2a1a;
  color: #d5a55b;
}

.ni-list__subject {
  flex: 1;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  font-size: 13px;
  color: #ddd;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ni-list__duration {
  font-size: 11px;
  color: #888;
  flex-shrink: 0;
}

.ni-list__status {
  font-size: 8px;
  flex-shrink: 0;
}

.ni-list__status--ok {
  color: #4caf50;
}

.ni-list__status--error {
  color: #e55;
}

.ni-list__time {
  font-size: 11px;
  color: #666;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  flex-shrink: 0;
}
</style>
